import React, { useEffect, useContext, useState } from 'react';
import { BlogContext } from '../../context/BlogContext';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import '../../style/Blog.css';
import PostCard from '../Layout/PostCard';

const BlogList = () => {
  const { blogs, getBlogs } = useContext(BlogContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        await getBlogs();
      } catch (err) {
        setError('Failed to load blogs. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, [getBlogs]);

  if (loading) return (
    <div className="text-center mt-5">
      <Spinner animation="border" variant="dark" />
    </div>
  );

  if (error) return (
    <div className="text-center mt-5">
      <Alert variant="danger">{error}</Alert>
    </div>
  );

  const filteredBlogs = [...blogs]
  .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
  .filter(blog =>
    blog.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container className="mt-5 mb-4">
      <div className="retro-window">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h1 className="text-center mb-4">All Posts</h1>
        <div className="mb-3 text-center">
  <input
    type="text"
    className="form-control w-75 mx-auto"
    placeholder="Search by title..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>

      </div>
      <Row className="justify-content-center g-4">
      {filteredBlogs.length === 0 ? (
          <Col xs={12} className="text-center">
            <p></p>
          </Col>
        ) : (
          filteredBlogs.map(blog => (
            <Col key={blog._id} xs={12} md={6} lg={4}>
              <PostCard post={blog} />
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
};

export default BlogList;
